import { userActions } from './user-slice';
import { getData } from '../common-actions';
import { fetchUsers } from '../../lib/api';

export const getUsers = (token, signal) => {

  return getData({
    token: token,
    actions: userActions,
    fetchFn: (token) => fetchUsers(token, signal),
    dataKey: "users",
    name: "get users",
    setFunctionName: "setUsers"
  });
};